<template>
  <div>
    <div class="container-fluid">
      <div class="page-header">
        <Breadcrumbs main="" title="Site Dashboard" />
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body d-flex flex-wrap justify-content-between align-items-center">
              <div>
                <h5 class="mb-0">{{ storeTitle }}</h5>
                <small class="text-muted">{{ host }}</small>
              </div>
              <div>
                <button
                  class="btn btn-light btn-sm mr-2"
                  :disabled="loading"
                  @click="load()"
                >
                  <feather
                    type="refresh-cw"
                    style="width:14px;height:14px"
                    class="mr-1"
                  ></feather>
                  Refresh
                </button>
                <button class="btn btn-primary btn-sm" @click="changeStore">
                  Change store
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status"></div>
        <p class="mt-2 text-muted mb-0">Loading store data…</p>
      </div>

      <div v-else-if="error" class="alert alert-danger" role="alert">
        Unable to load store data: {{ error }}
      </div>

      <template v-else-if="stats">
        <KpiCards :stats="stats" />
        <div class="row">
          <TodoPanel :stats="stats" />
          <SalesChart :stats="stats" />
        </div>
        <div class="row">
          <OrderStatus :stats="stats" />
          <TopProducts :stats="stats" />
          <TopCustomers :stats="stats" />
        </div>
        <LatestOrders :stats="stats" />
      </template>
    </div>
  </div>
</template>

<script>
import KpiCards from "../components/dashboard/live/kpi-cards.vue";
import TodoPanel from "../components/dashboard/live/todo-panel.vue";
import SalesChart from "../components/dashboard/live/sales-chart.vue";
import OrderStatus from "../components/dashboard/live/order-status.vue";
import TopProducts from "../components/dashboard/live/top-products.vue";
import TopCustomers from "../components/dashboard/live/top-customers.vue";
import LatestOrders from "../components/dashboard/live/latest-orders.vue";
import {
  getSelectedHost,
  fetchStoreData,
  computeStats
} from "../utils/store-stats";

export default {
  components: {
    KpiCards,
    TodoPanel,
    SalesChart,
    OrderStatus,
    TopProducts,
    TopCustomers,
    LatestOrders
  },
  data() {
    return {
      host: null,
      store: null,
      stats: null,
      loading: false,
      error: null
    };
  },
  created() {
    this.host = getSelectedHost();
    if (!this.host) {
      this.$router.push("/dashboard/default");
      return;
    }
    this.load();
  },
  computed: {
    storeTitle() {
      return (this.store && this.store.title) || this.host;
    }
  },
  methods: {
    changeStore() {
      this.$router.push("/dashboard/default");
    },
    async load() {
      if (!this.host) {
        return;
      }
      this.loading = true;
      this.error = null;
      try {
        const data = await fetchStoreData(this.host);
        this.store = data.store;
        this.stats = computeStats(data);
      } catch (e) {
        console.error("Site dashboard load error:", e);
        this.error = e && e.message ? e.message : String(e);
        this.stats = null;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
